import PropTypes from "prop-types"
import { map, every, isObject, toUpper } from "lodash"
import { Card } from "@mui/material"
import { DATE } from "helpers/shapes"
import { emptyOrOnlyOneFacetPerClassification, onlyOneFacetPerTier } from "helpers/classification"
import FacetList from "./components/list"
import FacetTieredList from "./components/list/tiered"
import FullFacetsList from "./components/full-list"
import { FACET_TYPE } from "./shapes"
import "./styles.scss"

const SecuritiesFinderFacets = ({ filterId, facetTypes, toggleFacet, toggleClassificationFacets, expanded, expandFacet, classifications, close }) => {
  if (!filterId || every(facetTypes, type => (type.facets.length <= 1 || (type.type === "classification" && emptyOrOnlyOneFacetPerClassification(type.facets))))) {
    return null
  }
  return <Card className="modules_securities-finder-facets">
    {map(facetTypes, ({ type, facets, selected }) => {
      // if its a classification
      if (isObject(facets) && !Array.isArray(facets)) {
        return map(facets, (f, key) => {
          if (onlyOneFacetPerTier(f)) { return null }
          return (<FacetTieredList
            key={`${type}_${key}`}
            facets={f}
            type={toUpper(key)}
            selected={selected}
            toggleFacet={toggleFacet}
            toggleClassificationFacets={toggleClassificationFacets}
            expandFacet={expandFacet}
          />)
        })
      } else {
        return <FacetList key={type} facets={facets} type={type} selected={selected} toggleFacet={toggleFacet} expandFacet={expandFacet} />
      }
    })}
    <FullFacetsList close={close} toggleFacet={toggleFacet} facetTypes={facetTypes} type={expanded} toggleClassificationFacets={toggleClassificationFacets} classifications={classifications} />
  </Card>
}

SecuritiesFinderFacets.propTypes = {
  filterId: PropTypes.string,
  facetTypes: PropTypes.arrayOf(FACET_TYPE).isRequired,
  expanded: PropTypes.string,
  toggleFacet: PropTypes.func.isRequired,
  toggleClassificationFacets: PropTypes.func.isRequired,
  expandFacet: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  classifications: PropTypes.object.isRequired,
  selectedDate: DATE,
}

export default SecuritiesFinderFacets
